import { UploadedFileDto } from "@/api";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Typography from "@/elements/Typography";
import { useTranslation } from "react-i18next";

export default function FileDownload({
  file,
  downloadUrl,
}: {
  file?: UploadedFileDto | null;
  downloadUrl?: string | null;
}) {
  const { t } = useTranslation();

  if (!file) {
    return (
      <Typography>
        <em>{t("fileField.nessunFile")}</em>
      </Typography>
    );
  }

  return (
    <a
      href={downloadUrl ?? undefined}
      target="_blank"
      rel="noreferrer"
      style={{ display: "flex", alignItems: "center" }}
    >
      <FileDownloadIcon sx={{ mr: 1 }} />
      {file.fileName}
    </a>
  );
}
